/**
 * 런타임 주입 설정 — 배포는 같은 이미지를 쓰고 컨테이너 기동 시 `/config.js` 가
 * `window.__CTCELLS_CONFIG__` 를 채운다(docs/deploy.md 「설정 주입 = 런타임」).
 *
 * 🔴 값을 코드에 박지 않는다. 읽는 자리는 이 파일 하나다.
 * ⚠ 값의 출처가 **사람이 손으로 쓴 파일**이므로 전부 방어적으로 읽는다 — 형이 틀리면 무시한다.
 *   (틀린 값을 그대로 믿고 임계·주소를 쓰면 조용히 잘못 동작한다)
 */

/** `/config.js` 가 채우는 전역. 섹션 이름만 알고 내용은 각 소비자가 좁혀 읽는다. */
declare global {
  var __CTCELLS_CONFIG__: Record<string, unknown> | undefined
}

function root(): Record<string, unknown> {
  const raw = globalThis.__CTCELLS_CONFIG__
  return isRecord(raw) ? raw : {}
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/** 런타임 설정의 한 섹션. 없거나 객체가 아니면 `undefined` */
export function runtimeSection(name: string): Record<string, unknown> | undefined {
  const value = root()[name]
  return isRecord(value) ? value : undefined
}

/** 양의 유한수만 받는다. 0·음수·NaN·문자열은 「값 없음」으로 본다 — 추측으로 메우지 않는다 */
export function positiveNumber(value: unknown): number | undefined {
  if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return undefined
  return value
}

/** 문자열로 들어온 수(환경변수)도 같은 규칙으로 받는다 */
export function positiveNumberFromText(value: string | undefined): number | undefined {
  if (value === undefined || value.trim() === '') return undefined
  return positiveNumber(Number(value))
}
